import { LoadingIcon as LoadingDs, Typography } from "@packages/ds";
import styled from "styled-components";

import * as Code from "ds/Code";
import { Separator as DSSeparator } from "ds/Dropdown";

export const SimpleBodyText = styled(Typography.BodyText)`
  display: inline;
`;

export const EnvironmentNameWrapper = styled.span`
  font-weight: 600;
`;

export const CheckboxWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const Separator = styled(DSSeparator)`
  margin: 24px 0px 20px 0px;
`;

export const DialogWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 16px;
`;

export const ModalDescription = styled(Typography.BodyText)`
  margin-bottom: 24px;
`;

export const CodeBlock = styled(Code.Block)`
  & > code {
    min-height: 22px;
  }
`;

export const Loading = styled(LoadingDs)`
  display: block;
  margin: 0 auto;
`;

export const LoadingSuccess = styled(Loading)`
  margin: 50px 0 0 auto;
`;
